import styled from '@emotion/styled';
import { media } from '@utex/ui-kit';

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 4rem 5rem;

  @media ${media.phonablet} {
    padding: 1.6rem 1.4rem;
  }
`;

export const Form = styled('form')`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  width: 100%;
`;

export const FormContent = styled('div')`
  flex-grow: 1;
`;

export const FormFooter = styled('div')`
  flex-shrink: 0;
  display: flex;
  margin-top: 2rem;

  @media ${media.phonablet} {
    flex-direction: column-reverse;
    text-align: center;
  }
`;

export const Factoids = styled('div')`
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
`;
